import { connect } from "react-redux";
import React, { Component } from "react";

import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";
import { patientRequests } from "@/api/(requests)/patient";
import { Profile } from "@/components/Patient/Profile/Profile";
import ProfileLoader from "@/components/Common/Loaders/ProfileLoader";
import { setDynamicRouteConfiguration } from "@/redux/actions/navbar";

import { loadPatientInsuranceImagesUrlToState } from "./PatientInsurance";

class PatientProfile extends Component {
  state = {
    insuranceImageUrls: {
      pbUrl: null,
      pfUrl: null,
      sbUrl: null,
      sfUrl: null,
    },
    patientAvatar: null,
    patientProfile: null,
  };

  componentDidMount() {
    const dynamicRouteConfig = {};

    dynamicRouteConfig["logoSection"] = { title: "Profile" };
    this.props.setDynamicRouteConfiguration(dynamicRouteConfig);
    this.getProfile();
  }

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
  }

  getProfile = async () => {
    try {
      let response = await patientRequests.fetch_profile({ context: { showLoader: false } });

      this.setState({
        patientProfile: response && response.user,
      });
      loadPatientInsuranceImagesUrlToState(response.user, this);
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return (
      <ContainerContent>
        <ContainerTitle title="Profile" />

        {this.state.patientProfile ? (
          <Profile
            profileData={this.state.patientProfile}
            reloadImg={(user) => loadPatientInsuranceImagesUrlToState(user, this)}
          />
        ) : (
          <ProfileLoader />
        )}
      </ContainerContent>
    );
  }
}

export default connect(null, { setDynamicRouteConfiguration })(PatientProfile);
